/* FÉNIX R07.93 — CHECKOUT AUTHORITY
   Sustituye el gate global legacy por validación de términos limitada al mismo
   formulario de carrito. No bloquea controles que no tengan #agree asociado. */
(function(){
  'use strict';

  var LEGACY_SELECTOR='[name="checkout"], [name="goto_pp"], [name="goto_gc"]';

  function removeLegacyGlobalGate(){
    if(!window.jQuery)return;
    try{
      window.jQuery('body').off('click',LEGACY_SELECTOR);
    }catch(e){}
  }

  function needsTerms(trigger){
    return !!(trigger && trigger.matches && trigger.matches(LEGACY_SELECTOR));
  }

  function initForm(form){
    if(!form || form.dataset.nmCheckoutAuthority==='v93')return;

    var checkout=form.querySelector('[name="checkout"]');
    if(!checkout)return;

    form.dataset.nmCheckoutAuthority='v93';

    /* Restore intended visual/action hooks without forcing unrelated payment UI. */
    checkout.classList.add('nm-checkout-main','btn','nm-cart-checkout');
    checkout.style.removeProperty('pointer-events');
    checkout.style.removeProperty('opacity');
    checkout.disabled=false;
    checkout.removeAttribute('disabled');

    var agree=form.querySelector('#agree');
    if(agree){
      agree.setAttribute('aria-required','true');
      agree.required=true;
    }

    function clearTermsState(){
      if(!agree)return;
      agree.setCustomValidity('');
      form.classList.remove('nm-terms-needs-attention');
    }

    function validateTerms(event,trigger){
      if(!agree || !needsTerms(trigger))return true;
      if(agree.checked){
        clearTermsState();
        return true;
      }

      if(event){
        event.preventDefault();
        event.stopPropagation();
      }

      agree.setCustomValidity('Para continuar, acepta los términos y condiciones.');
      form.classList.add('nm-terms-needs-attention');

      try{ agree.reportValidity(); }catch(e){}
      try{ agree.focus({preventScroll:false}); }catch(e){ try{agree.focus();}catch(_e){} }
      return false;
    }

    form.addEventListener('click',function(event){
      var trigger=event.target && event.target.closest ? event.target.closest(LEGACY_SELECTOR) : null;
      if(!trigger || !form.contains(trigger))return;
      validateTerms(event,trigger);
    },true);

    form.addEventListener('submit',function(event){
      var trigger=event.submitter || null;
      if(trigger && needsTerms(trigger)){
        if(!validateTerms(event,trigger))return;
        checkout.disabled=false;
        checkout.removeAttribute('disabled');
      }
    },true);

    if(agree){
      agree.addEventListener('change',function(){
        if(agree.checked)clearTermsState();
      });
    }
  }

  function init(){
    /* The old body-level jQuery handler is registered on DOMContentLoaded.
       Remove only that exact delegated selector; leave other cart handlers intact. */
    removeLegacyGlobalGate();
    setTimeout(removeLegacyGlobalGate,0);
    setTimeout(removeLegacyGlobalGate,160);

    var forms=document.querySelectorAll('form[action="/cart"], form[action$="/cart"]');
    forms.forEach(initForm);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }
})();
